import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { SuperAdminApartmentDetailDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

type LocationState = {
    apartment?: SuperAdminApartmentDetailDto;
};

export const useSuperAdminRoomDetailApi = (id?: string) => {
    const axiosInstance = useAxiosAuth();
    const location = useLocation();
    const locationState = location.state as LocationState | null;
    const stateApartment = locationState?.apartment;
    const placeholderApartment = stateApartment?.id === id ? stateApartment : undefined;

    const { data, isLoading, error } = useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.apartments.queryKeys.detail, id],
        enabled: Boolean(id),
        placeholderData: placeholderApartment,
        queryFn: async (): Promise<SuperAdminApartmentDetailDto> => {
            const response = await axiosInstance.get<SuperAdminApartmentDetailDto>(
                `${ApiConfig.queries.superAdmin.data.apartments.endpoints.detail}/${id}`,
            );
            return response.data;
        },
    });

    return {
        apartment: data,
        isLoading,
        error,
    };
};
